// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

"use client";

import { createTheme } from "@mui/material/styles";

import { customShadows } from "./custom-shadows";
import { overrides } from "./overrides";
import { palette } from "./palette";
import { shadows } from "./shadows";
import { typography } from "./typography";

const themeWithoutComponent = createTheme({
    palette,
    typography,
    shadows: shadows(),
    customShadows: customShadows(),
    shape: { borderRadius: 8 },
});

themeWithoutComponent.components = {
    ...overrides(themeWithoutComponent),
    MuiUseMediaQuery: {
        defaultProps: {
            noSsr: true,
        },
    },
};

export const theme = themeWithoutComponent;
